export default {
    serverHost: 'https://fx-api.jiangxin-food.com',
    imageServer:"https://pic.jiangxin-food.com/"
}